import React from 'react';
import { Link } from 'react-router-dom';

function EngineeringHighlightsGrid() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-0.5 bg-cogBrand w-full overflow-hidden select-none font-sans">

      {/* Industry Impact Card */}
      <Link 
        to="/services" 
        className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-cogBrand via-cogInk to-black min-h-[400px] flex items-center p-8 block hover:opacity-95 transition-opacity"
      >
        {/* Background Pattern */}
        <div
          className="absolute inset-0 opacity-15 pointer-events-none"
          style={{
            backgroundImage: 'radial-gradient(circle, rgba(255,255,255,.16) 1px, transparent 1.5px)',
            backgroundSize: '18px 18px',
          }}
        />

        {/* Content */}
        <div className="relative z-10">
          <h2 className="text-5xl text-cogLight font-bold leading-tight max-w-xl">
            Advance<br />
            <span className="text-cogAccentBlue">Engineering Excellence</span> 
          </h2>
        </div>
      </Link>

      {/* Block 2: Sustainability Net-Zero Core */}
      <Link 
        to="/services" 
        className="relative group min-h-[400px] flex flex-col justify-end p-8 text-cogLight overflow-hidden block"
      >
        <img
          src="https://www.zuken.com/en/wp-content/uploads/sites/2/2018/10/engineers-using-e3series-electrical-design.png"
          alt="nexten Sustainability Net-Zero Commitment"
          className="absolute inset-0 w-full h-full object-cover object-center scale-100 group-hover:scale-105 transition-transform duration-700 ease-out pointer-events-none"
        />
        {/* Vignette layout gradient overlay mapping closely to original design parameters */}
        <div className="absolute inset-0 bg-gradient-to-t from-cogInk/80 via-cogInk/30 to-cogInk/5" />

        <div className="relative z-10 max-w-sm">
          <h3 className="text-3xl font-medium tracking-tight leading-snug">
            Advanced 3D Routing, DMU, and VLO Engineering
          </h3>
        </div>
      </Link>

      {/* Block 3: Ignite Growth Capco Solutions */}
      <Link 
        to="/services" 
        className="relative group bg-cogInk p-8 flex flex-col justify-end text-cogLight min-h-[400px] overflow-hidden block"
      >
        {/* Concentric glowing geometric aura overlay */}
        <div
          className="absolute -right-16 -top-16 w-72 h-72 rounded-full pointer-events-none opacity-60 mix-blend-screen"
          style={{
            background:
              'radial-gradient(circle, transparent 55%, rgba(3,152,210,0.2) 56%, transparent 58%), radial-gradient(circle, transparent 65%, rgba(0,102,204,0.15) 66%, transparent 68%)',
          }}
        />

        {/* Deep fluid vector aesthetic background alignment */}
        <img
          src="https://www.zuken.com/en/wp-content/uploads/sites/2/2020/09/mbse-wireharness-1510x731.jpg"
          alt="Capco GenAI Network Graphics"
          className="absolute inset-0 w-full h-full object-cover object-right opacity-45 mix-blend-screen scale-100 group-hover:scale-105 transition-transform duration-700 ease-out pointer-events-none"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />

        <div className="relative z-10 max-w-xs">
          <h3 className="text-3xl font-medium tracking-tight leading-snug">
            OEM Engineering and Harness Design Support
          </h3>
        </div>
      </Link>

    </div>
  );
}

export default EngineeringHighlightsGrid;